import { StyleSheet } from 'react-native'

import { DS } from '../../design-system'
import { fontFamily } from '../../theme'

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F6F2E9',
    paddingHorizontal: 20
  },
  imageContainer: {
    paddingHorizontal: 12,
    backgroundColor: '#F6F2E9',
    alignItems: 'center'
  },
  image: {
    marginTop: -12,
    width: '100%'
  },
  bottomSheetHandleStyle: {
    backgroundColor: '#F6F2E9',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    paddingTop: 0
  },
  bottomSheetIndicatorStyle: {
    display: 'none'
  },
  cancelButton: {
    paddingHorizontal: DS.spacing[16],
    paddingVertical: 12.5,
    backgroundColor: DS.palette['Brand/Cream'],
    borderRadius: DS.spacing[24],
    borderColor: DS.palette['Brand/Light Grey'],
    borderWidth: 1,
    width: '28%',
    height: 48
  },
  deleteButton: {
    backgroundColor: DS.palette['Brand/Cream'],
    borderRadius: DS.spacing[24],
    borderColor: DS.palette['Brand/Light Grey'],
    borderWidth: 1,
    width: '15%',
    height: 48,
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  },
  submitGradientButton: {
    borderRadius: DS.spacing[24],
    width: '70%',
    height: 48
  },
  actionsContainer: {
    gap: 6,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginVertical: 15
  },
  userResponseInput: {
    backgroundColor: DS.palette['Global/White'],
    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardRegular,
    padding: 16,
    borderRadius: 12,
    borderColor: DS.palette['Brand/Dark Grey'],
    color: DS.palette['Global/Black'],
    width: '88%',
    minHeight: 40,
    maxHeight: 216,
    textAlignVertical: 'center', // Ensures vertical alignment of text and placeholder (for Android)
    // lineHeight: 24, // Optional: Helps in adjusting line spacing to improve vertical alignment
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    gap: 8,
    paddingTop: 15,
    // Shadow for Android
    elevation: 4
  },
  submitButton: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  userInitialBadge: {
    justifyContent: 'center',
    alignItems: 'center',
    height: 32,
    width: 32,
    borderRadius: 16,
    backgroundColor: DS.palette['Brand/Pink']
  },
  MessageTopContainer: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  spadeStyle: {
    marginTop: 20
  },
  discription: {
    marginBottom: 16
  },
  cardContainer: {
    padding: 16,
    height: 104,
    marginBottom: 12,
    borderRadius: 12
  },
  maxSizeView: {
    marginRight: 0,
    marginVertical: 5
  },
  buttonContainer: {
    marginTop: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  buttonView: {
    paddingHorizontal: DS.spacing[16],
    paddingVertical: 12.5,
    backgroundColor: DS.palette['Brand/Cream'],
    borderRadius: DS.spacing[48],
    borderColor: DS.palette['Brand/Light Grey'],
    borderWidth: 1,
    width: '48%',
    height: 48
  },
  feedbackContainer: {
    paddingHorizontal: 10,
    paddingBottom: 10
  },
  keyboardAvoidingContainer: {
    flex: 1,
    width: '100%',
    backgroundColor: '#00000050',
    justifyContent: 'flex-end'
  }
})
